import { formatValue } from '../utils';

type Props = {
    value: number;
    hasError?: boolean;
};

const ValueWithDiffError = ({ hasError, value }: Props) => {
    const style = hasError ? { color: 'var(--error-normal)' } : undefined;
    return <strong style={style}>{formatValue(value)}</strong>;
};

export default ValueWithDiffError;
